module.exports = __webpack_public_path__ + "static/media/solo-card-3-points.b823fe5a.png";